export const API_URL =
  "https://ba0f4652-2c98-4dfa-8560-acb5b84ac1b4.mock.pstmn.io";
export default API_URL;
